var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotateClockwise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rotate-clockwise"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.502 3.35972C7.36697 3.35633 6.26962 3.76671 5.41535 4.51405C4.56109 5.26139 4.00847 6.29446 3.86096 7.41986C3.8131 7.78492 3.47837 8.04208 3.1133 7.99423C2.74823 7.94637 2.49108 7.61164 2.53893 7.24657C2.7286 5.79962 3.4391 4.4714 4.53744 3.51053C5.63578 2.54967 7.04667 2.02203 8.50598 2.02639C9.9653 2.03076 11.373 2.56682 12.4656 3.53424C13.5582 4.50166 14.2607 5.83411 14.4417 7.28216C14.6227 8.73021 14.2698 10.1946 13.4489 11.4012C12.6281 12.6078 11.3957 13.4739 9.98235 13.8373C8.56901 14.2008 7.07166 14.0366 5.77059 13.3757C5.03248 13.0008 4.38625 12.4805 3.86661 11.8529L3.86661 13.3332C3.86661 13.7014 3.56813 13.9999 3.19994 13.9999C2.83176 13.9999 2.53328 13.7014 2.53328 13.3332L2.53328 9.99988C2.53328 9.63169 2.83176 9.33321 3.19994 9.33321H3.51776C3.52799 9.33298 3.53821 9.33298 3.5484 9.33321H6.53328C6.90147 9.33321 7.19994 9.63169 7.19994 9.99988C7.19994 10.3681 6.90147 10.6665 6.53328 10.6665H4.64002C5.07879 11.306 5.67333 11.8308 6.37447 12.187C7.38641 12.701 8.55102 12.8287 9.65028 12.546C10.7495 12.2633 11.7081 11.5897 12.3465 10.6512C12.9849 9.71277 13.2595 8.5738 13.1187 7.44754C12.9779 6.32127 12.4315 5.28493 11.5817 4.53249C10.7319 3.78005 9.63702 3.36312 8.502 3.35972Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateClockwise);
export default __webpack_public_path__ + "static/media/rotateClockwise.f8780681ead8cc08ba0714fb0482b462.svg";
export { ForwardRef as ReactComponent };